export default __webpack_public_path__ + "4121521f93e0fa856d31acbabf63e871.jpeg";